import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import { MediaService } from "@/services/media-service";
import type {
  GeneratePresignedUrlRequestDto,
  GeneratePresignedUrlResponseDto
} from "@/types";

type UsePostGeneratePresignedUrlMutationParams = {
  options?: UseMutationOptions<
    GeneratePresignedUrlResponseDto,
    unknown,
    GeneratePresignedUrlRequestDto
  >;
};

export const usePostGeneratePresignedUrlMutation = ({
  options
}: UsePostGeneratePresignedUrlMutationParams = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return await MediaService.generatePresignedUrl({ payload });
    },
    ...options
  });
};
